import firebase from 'firebase/app'
import 'firebase/database'

// TODO: Move to env
let config = {
  apiKey: 'AIzaSyAkzu9IHPJVU6I-Tgcv2_Q93IpLRz98q0Q',
  authDomain: 'mmpof3.firebaseapp.com',
  databaseURL: 'https://mmpof3.firebaseio.com',
  projectId: 'mmpof3',
  storageBucket: 'mmpof3.appspot.com',
  messagingSenderId: '760549006680',
  appId: '1:760549006680:web:ac66861bd8aad5de7f192d',
}

export default firebase.initializeApp(config).database()
